import React from 'react';
import ReactDom from 'react-dom';
import Modal from '../modal/Modal';
import Button from '../button/Button';
import './index.scss';

function Message(props) {
  const { title, content, footer, bodyStyle = {} } = props;
  return (
    <Modal
      visible
      bodyStyle={Object.assign({ width: 274 }, bodyStyle)}
    >
      <h3 className="message-title">{title}</h3>
      <div className="message-content">
        {content}
      </div>
      <div className="message-footer">
        {footer}
      </div>
    </Modal>
  );
}

function createMessage(props) {
  const div = document.createElement('div');
  document.body.appendChild(div);

  ReactDom.render(
    <Message
      {...props}
    />,
    div
  );

  return {
    destroy() {
      ReactDom.unmountComponentAtNode(div);
      document.body.removeChild(div);
    }
  };
}

function noop() {}

export default {
  alert(msg, callback, title = '提示') {
    let messageInstance = null;

    function onClose() {
      messageInstance.destroy();
      // eslint-disable-next-line no-unused-expressions
      callback && callback();
    }

    messageInstance = createMessage({
      title,
      content: msg,
      footer: <div className="message-btn-group"><Button type="primary" onClick={onClose}>确定</Button></div>
    });
  },
  confirm(msg, confirmCb = noop, cancelCb = noop) {
    let messageInstance = null;

    function onClose(type) {
      messageInstance.destroy();
      type === 'confirm'
        ? confirmCb()
        : cancelCb();
    }

    messageInstance = createMessage({
      title: '提示',
      content: msg,
      footer: (
        <div className="message-btn-group">
          <Button type="info" onClick={() => onClose('cancel')}>取消</Button>
          <Button type="primary" onClick={() => onClose('confirm')}>确定</Button>
        </div>
      )
    });
  },
  skipConfirm(msg, confirmCb = noop, cancelCb = noop) {
    let messageInstance = null;

    function onClose(type) {
      messageInstance.destroy();
      if (type === 'confirm') {
        confirmCb();
      } else if (type === 'skip') {
        //  记录当日时间到本地缓存
        const t = new Date();
        const currentDay = `${t.getFullYear()}-${t.getMonth() + 1}-${t.getDate()}`;
        localStorage.setItem('current_day', currentDay);
        confirmCb();
      } else if (type === 'cancel') {
        cancelCb();
      }
    }

    messageInstance = createMessage({
      title: '提示',
      content: msg,
      footer: (
        <div className="message-btn-group message-warn">
          <Button type="info" className="message-warn-btn" onClick={() => onClose('cancel')}>取消</Button>
          <Button type="info" className="message-warn-btn" onClick={() => onClose('skip')}>当日不再提醒</Button>
          <Button type="primary" className="message-warn-btn" onClick={() => onClose('confirm')}>确定立即启用</Button>
        </div>
      )
    });
  }
};
